import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LockKey } from '@phosphor-icons/react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/api/admin/login`, { password });
      localStorage.setItem('admin_token', response.data.token);
      toast.success('Login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-[#11141D] border border-[#1E293B] rounded-lg p-8">
        <div className="text-center mb-8">
          <LockKey size={64} className="mx-auto text-[#007AFF] mb-4" weight="fill" />
          <h1 className="text-3xl font-['JetBrains_Mono'] font-bold" data-testid="admin-login-title">
            Admin Login
          </h1>
          <p className="text-[#94A3B8] mt-2">Enter password to access admin panel</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Label>Password</Label>
            <Input
              data-testid="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent border-[#334155]"
              placeholder="Enter admin password"
            />
          </div>

          <Button
            data-testid="login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-[#0047AB] hover:bg-[#005DF0] font-['JetBrains_Mono']"
          >
            {loading ? 'Logging in...' : 'Login'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="text-[#94A3B8] hover:text-[#F8FAFC] font-['JetBrains_Mono']"
            data-testid="back-home-btn"
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
